import React from "react";
import DepartureSection from "../PlantMaterialControl/DepartureSection";
import {FIXED_ARRIVAL_SECTION} from "../../../Model/Model";
import CustomDateTimePicker from "../../../../../../components/CustomDateTimePicker";
import { PERIOD_TIME_UNIT_ENUM } from "../../../../../../enums/PeriodTimeUnitEnum";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @description
 * Renders the information fields of a poultry truck exit form: the date on
 * which the truck is expected to leave and the arrival of the vehicle, which is
 * always enabled because the movement is fixed and the user cannot select its
 * direction.
 *
 * @param {Function} t - Translation function.
 * @param {Object} materialRequest - Current form information.
 * @param {Function} handleChange - Change handler of the form.
 * @param {boolean} emptyFields - Indicates whether the required fields must be highlighted.
 */
const PoultryTruckExitInformationFields = ({
    t,
    materialRequest,
    handleChange,
    emptyFields
}) => {

    return (
        <>
            <div className={"col-12"}>
                <CustomDateTimePicker
                    id={`dp_pte_expected_exit_date`}
                    name={'expectedMovementDate'}
                    onChange={(e) => {
                        handleChange({target: {value: e, name: 'expectedMovementDate'}});
                    }}
                    trans={'expected_exit_date'}
                    value={materialRequest?.expectedMovementDate}
                    required={true}
                    openTo={PERIOD_TIME_UNIT_ENUM.DAYS.key}
                    disablePast={true}
                    emptyFields={emptyFields}
                />
            </div>

            <div className={"col-12 mb-3"}>
                <DepartureSection
                    t={t}
                    section={FIXED_ARRIVAL_SECTION}
                    materialRequest={materialRequest}
                    handleChange={handleChange}
                    emptyFields={emptyFields}
                />
            </div>
        </>
    );
};

export default PoultryTruckExitInformationFields;
